import ko from "knockout";
import $ from "jquery";
import register from "flow/knockout/register";

register.registerKnockoutBinding("modal", {
    init: function (element, valueAccessor) {
        $(element).modal({
            backdrop: false,
            show: false
        });

        $(element).draggable({
            handle: ".modal-header"
        });

        const value = valueAccessor();
        if (typeof value === "function") {
            $(element).on("hide.bs.modal", function () {
                value(false);
            });
        }

        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            console.warn('Bootstrap 3 does not support "disposal", callbacks.');
        });
    },
    update: function (element, valueAccessor) {
        const value = valueAccessor();
        if (ko.utils.unwrapObservable(value)) {
            $(element).modal("show");
        } else {
            $(element).modal("hide");
        }
    }
});

window.define('flow/bindings/modalBinding', [], function() { return __webpack_module__.exports; });